import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: 700,
    borderRadius: 100,
    height: 56,
    width: 243,
  },
}));
